export const SEARCH_HISTORY_STORAGE_KEY = 'header_search_history';
export const LAST_USED_PROJECT_KEY = 'addto_last_used_project';
// eslint-disable-next-line
export const TA_V2_DEFAULT_HOST= typeof __DEFAULT_HOST__ !== 'undefined' ?  __DEFAULT_HOST__ : '';
export const PAGE_SIZE = 12;

export const NOT_FETCHED = 'NOT_FETCHED';

export const SCREENS = {
  DEFAULT: 'DEFAULT',
  PROJECT_SELECT_PROJECT: 'PROJECT_SELECT_PROJECT',
  PROJECT_CREATE_PROJECT: 'PROJECT_CREATE_PROJECT',
  PROJECT_ZERO_STATE: 'PROJECT_ZERO_STATE',
  MINI_PIP_BASE: 'MINI_PIP_BASE',
  MINI_PIP_FULL: 'MINI_PIP_FULL',
  MINI_PIP_PRODUCT_OVERVIEW: 'MINI_PIP_PRODUCT_OVERVIEW',
  MINI_PIP_PRODUCT_SPECS: 'MINI_PIP_PRODUCT_SPECS',
  MINI_PIP_PRODUCT_REVIEWS: 'MINI_PIP_PRODUCT_REVIEWS',
  MINI_PLP: 'MINI_PLP',
  LIST_CREATE_LIST: 'LIST_CREATE_LIST',
  LIST_SELECT_LIST: 'LIST_SELECT_LIST',
  LIST_SELECT_GROUP: 'LIST_SELECT_GROUP',
  LIST_SUCCESS: 'LIST_SUCCESS',
  STARTER_LISTS: 'STARTER_LISTS',
  SIGN_IN: 'SIGN_IN',
  LOADING: 'LOADING',
  ADD_TO_SELECTION: 'ADD_TO_SELECTION',
  COPY_PROJECT_MESSAGING: 'COPY_PROJECT_MESSAGING',
  LOADING_STATUS: 'LOADING_STATUS',
  PRODUCT_EXCEPTIONS: 'PRODUCT_EXCEPTIONS',
  COPY_LIST_SUMMARY: 'COPY_LIST_SUMMARY',
  COPY_LIST_PRODUCTS: 'COPY_LIST_PRODUCTS',
  GENERATED_LIST_INTENTS_PREVIEW: 'GENERATED_LIST_INTENTS_PREVIEW',
  AI_LOADING_ANIMATION: 'AI_LOADING_ANIMATION',
  BATHROOM_QUESTIONNAIRE: 'BATHROOM_QUESTIONNAIRE',
  MY_STORE: 'MY_STORE',
  DELIVERY_ZIP: 'DELIVERY_ZIP',
  DISPLAY_ITEM_DETAILS: 'DISPLAY_ITEM_DETAILS',
  CREATE_PROJECT_PREVIEW: 'CREATE_PROJECT_PREVIEW'
};

export const HEADER_TEXT = {
  PROJECT_SELECT_PROJECT: 'Select Project',
  PROJECT_CREATE_PROJECT: 'Create Project',
  PROJECT_ZERO_STATE: 'Add Items to Project',
  CREATE_PROJECT_PREVIEW: 'Add Items to Project',
  DEFAULT: 'Add Materials',
  ADD_TO_PROJECT: 'Add to Project',
  GENERATED_LIST_INTENTS_PREVIEW: 'Preview List',
  AI_LOADING_ANIMATION: 'Preview List',
  BATHROOM_QUESTIONNAIRE: 'Follow-Up Questions',
  STARTER_LISTS: 'Starter Lists',
  MINI_PIP_BASE: 'Product Details',
  MINI_PIP_PRODUCT_OVERVIEW: 'Overview',
  MINI_PIP_PRODUCT_SPECS: 'Specifications',
  MINI_PIP_PRODUCT_REVIEWS: 'Reviews',
};

export const ERROR = {
  // eslint-disable-next-line max-len
  INVALID_QUOTE_NAME: 'Invalid Quote Name: Only a-z, A-Z, 0-9 are allowed.',
  EMPTY_QUOTE_NAME: 'Quote name cannot be empty',
  // eslint-disable-next-line max-len
  INVALID_LIST_NAME: 'Invalid List Name: Only a-z, 0-9, ! @ # $ % ^ & * ( ) - _ + , . ? " \' : ; \\ are allowed.',
  EMPTY_LIST: 'List name cannot be empty',
  LIST_ALREADY_EXISTS: 'List name already exists',
  GENERAL_API_FAIL: 'Something went wrong, please try after sometime',
  EMPTY_GROUP_NAME_MESSAGE: 'Enter Group Name',
  INVALID_GROUP_LENGTH_MESSAGE: 'Group Names can be at most 50 characters',
  // eslint-disable-next-line max-len
  INVALID_PROJECT_TEXT_MESSAGE: 'Invalid Text: Only a-z, 0-9, ! @ # $ % ^ & * ( ) - _ + , . ? " \' : ; \\ are allowed.'
};

export const TRACK = {
  OPEN_DRAWER: 'save-to-favorites.track-overlay',
  BUTTON_CLICK: 'save-to-favorites.track-click',
  ADD_ITEM: 'save-to-favorites.track-add-item',
  ADD_PRODUCTS: 'save-to-favorites.track-add-products',
  CREATE_LIST_WITH_ITEM: 'save-to-favorites.create-a-list-with-item',
  CREATE_LIST_WITH_PRODUCTS: 'save-to-favorites.create-a-list-with-products',
  NEW_LIST_CREATED_WITH_PRODUCT_ADD: 'add-to.newListCreatedProductAdded',
  ADD_TO_LIST_ADD_ACTION: 'add-to.listAddAction',

  ADD_TO_LIST_MINI_LIST_DETAILS_OVERLAY: 'add-to.miniListDetailsOverlay',
  ADD_TO_LIST_MINI_LIST_DETAILS_BACK_PRESS: 'add-to.miniListDetailsBackButton',
  ADD_TO_LIST_COPY_FROM_LISTS_SELECTION: 'add-to.copyFromYourListsSelection',
  ADD_TO_LIST_COPY_LIST_EXIT_OVERLAY: 'add-to.copyFromYourListsExitOverlay',
  ADD_TO_LIST_COPY_FROM_LISTS_EXIT_ACTION: 'add-to.copyFromYourListsExitAction',
  ADD_TO_LIST_MINI_LIST_DETAILS_EXIT_ACTION: 'add-to.miniListDetailsExitAction',
  ADD_TO_OVERLAY_EXIT: 'add-to.overlay-exit',
  COPY_TO_SELECT_OVERLAY: 'add-to.copyToSelectListOrProjectOverlays',
  LIST_BUILDER_ENTRY_POINT_CLICK: 'list-builder.entryPointClick',
  LIST_BUILDER_OVERLAY: 'list-builder.options-overlay',
  LIST_BUILDER_STARTER_LIST_SELECTION: 'list-builder.starter-list-selection',
  LIST_BUILDER_ERROR: 'list-builder.error',
  LIST_BUILDER_BUILD_WITH_AI_SELECTION: 'list-builder.build-with-ai-selection',
  LIST_BUILDER_CUSTOMIZE_LIST_OVERLAY: 'list-builder.customize-list-overlay',
  LIST_BUILDER_PREVIEW_LIST_FORK_SELECTION: 'list-builder.preview-list-fork-selection',
  NO_PROJECTS_OVERLAY: 'add-to.noProjectsOverlay',
  PROJECT_OVERLAY_SEARCH: 'add-to.projectOverlaySearch',
  CHOOSING_THE_RIGHT_TOOL_OVERLAY: 'add-to.choosingTheRightToolOverlay'
};

export const SELECTION_TYPE = {
  PROJECT: 'project',
  LIST: 'list'
};

export const OPERATION_ADD_ITEMS = 'AddItems';
export const GROUP_ALREADY_EXITS_ERROR = 'Group already exists';

export const MOBILE_CHANNEL = 'mobile';
export const DELIMITER = ':';
export const DRAWERS = {
  LOADING: 'loading',
  CREATE_QUOTE: 'create-quote',
  ADD_TO_QUOTE: 'add-to-quote',
  SIGN_IN_WARNING: 'sign-in-warning',
  PRICE_CHANGE_WARNING: 'price-change-warning',
  SUCCESS: 'success',
  ERROR: 'error'
};
export const GENERIC_ERROR = 'Something went wrong. Please refresh and try again.';
export const DEFAULT_SELECTED_QUOTE = {
  // this needs to be the userId of the user that created the quote, not current user
  userId: '',
  quoteId: '',
  quoteName: ''
};

export const QUOTE_ACTIVE_STATUS = 'ACTIVE';
export const QUOTE_PENDING_STATUS = 'PENDING';

export const FULFILLMENT = {
  STH: 'ShipToHome',
  BOPIS: 'BOPIS',
  BOSS: 'ShipToStore',
  BODFS: 'DeliverFromStore',
  APPLIANCE: 'DirectDelivery'
};
export const PICKUP_FULFILLMENT = [FULFILLMENT.BOSS, FULFILLMENT.BOPIS];
export const DELIVERY_FULFILLMENT = [FULFILLMENT.STH, FULFILLMENT.BODFS, FULFILLMENT.APPLIANCE];

// role
export const USER_ADMIN = 'ADMIN';
export const PURCHASER = 'PURCHASER';

export const ADD_TO_TYPE = {
  LIST: 'List',
  QUOTE: 'Quote',
  PROJECT: 'Project',
  CART: 'Cart',
  COPY_PROJECT: 'CopyProject',
  DISPLAY_ITEM_DETAILS: 'DisplayItemDetails'
};

// Product Exceptions Constants
export const ITEMS_CANNOT_BE_QUOTED_MESSAGE = `item(s) can't be quoted online. Please copy and share these
items with your Home Depot Pro Associate for assistance.`;
export const ITEMS_QUOTED_BY_PRO_ASSOCIATE_MESSAGE = `Items quoted by a Pro Associate may need to be quoted
separately, resulting in multiple quotes. Would you like to continue without the item(s) below?`;
export const ADDITIONAL_HANDLING_MESSAGE = `The following product(s) require additional handling by a Home
Depot Pro Associate to quote or purchase at this time.`;
export const ADDITIONAL_ASSISTANCE_MESSAGE = `The following product(s) may be purchased online, but require
assistance from a Home Depot Pro Associate to quote at this time.`;
export const DISCONTINUED_OOS_MESSAGE = `The following product(s) are either discontinued or out of stock.
Contact your Home Depot Pro Associate for additional options.`;
export const UNAVAILABLE_MESSAGE = `other product(s) are missing information and are unavailable for quote
or purchase at this time.`;
export const COPY_SUCCESS = 'Successfully copied to clipboard';
export const COPY_ERROR = `An error has occurred. Please try copying item details to clipboard
again or refresh the page.`;

// Progress Bar Drawer Constants
export const PRODUCTS_LOADING_MESSAGE = `We are fetching important information for the items you have
selected. You will be redirected momentarily...`;

// Add To Selection Drawer Constants
export const TOO_MANY_PRODUCTS_MESSAGE = `We're sorry, you've exceeded the maximum number of items (89)
allowed in a quote. Select fewer items and try again.`;

// Numberical Constants
export const MAX_PI_QUERY_SIZE = 6;
export const MAX_QUOTE_ITEMS = 89;

// Analytics
export const ANALYTICS_SELECT_PROJECT = 'add-to.select-project';
export const ADD_ITEM_NEW_PROJECT = 'projects: add to project action to new project';
export const ADD_ITEMS_PROJECT_EXISTING_GROUP = 'projects: add to project action w/NO new Group created';
export const ADD_ITEMS_PROJECT_NEW_GROUP = 'projects: add to project action w/new group created';
export const ITEM_DETAILS_LINK = 'item details link';

export const CHANGE_TYPE = {
  NO_CHANGE: 0,
  CHANGED: 1,
  REMOVED: 2,
  NEW: 3
};
// Group Constants
export const DEFAULT_GROUP_NAME = 'Default Group';

export const COPY_FROM_PROJECT = 'copy_from_project';
export const COPY_FROM_LIST = 'copy_from_list';

// Feature switches
export const FORK_IN_THE_ROADS_FS_KEY = 'fs:isForkInTheRoadsEnabled';
